export default function FleetGallery() {
  const items = [
    { t: "Wheelchair Van", d: "Rear-entry ramp, Q-Straint securements.", img: "/images/fleet-wheelchair.jpg" },
    { t: "Ambulatory Van", d: "Low step, handholds, comfort seating.", img: "/images/fleet-ambulatory.jpg" },
    { t: "Stretcher Van", d: "Professional cot, safety restraints.", img: "/images/fleet-stretcher.jpg" },
  ];
  return (
    <section className="py-5">
      <div className="container">
        <h2 className="fw-bold h3 mb-3">Our Fleet</h2>
        <div className="row g-4">
          {items.map((v) => (
            <div className="col-12 col-md-6 col-lg-4" key={v.t}>
              <div className="card h-100 shadow-sm">
                <img className="card-img-top" src={v.img} alt={v.t} />
                <div className="card-body">
                  <h5 className="card-title">{v.t}</h5>
                  <p className="card-text text-secondary">{v.d}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
